import { createLifeomicActionTypes } from '../../util/createActionTypes';

export default createLifeomicActionTypes([
  'INITIALIZE_APP',
  'INITIALIZE_APP_START',
  'INITIALIZE_APP_END',
]);
